




























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Input from '@/main-components/common/Input.vue';
import TextArea from '@/main-components/common/TextArea.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import { ErrorResponse } from '@/utils/response';
import Dropdown, {
  DropdownOption,
} from '@/main-components/common/dropdown/Dropdown.vue';
import DropdownSubject, {
  DropdownSubjectValue,
} from './dropdown/DropdownSubject.vue';

export interface InputValue {
  value:
    | string
    | number
    | (string | number | boolean)[]
    | DropdownSubjectValue
    | boolean;
}

export interface InputData extends InputValue {
  name: string; // NOTE: Must be unique (work as unique ID also)
  type: string;
  isRequired?: boolean;
  placeholder?: string;
  maxWidth?: string;
  //For input only
  isEmail?: boolean;
  maxLength?: number;
  icon?: string;
  isIconFill?: boolean;
  hasMinimum?: number;
  maxNumber?: number;
  minNumber?: number;
  apiValidate?: (input: string) => Promise<boolean>;
  // For dropdown only
  dropdownOptions?: DropdownOption[];
  dropdownDependent?: string | number;
  dropdownWidth?: string;
  isMultiSelect?: boolean;
  // For dropdown subject only
  isFormRequired?: boolean;
  isChapterRequired?: boolean;
  isSingleChapter?: boolean;
  isHideForm?: boolean;
  isHideChapter?: boolean;
}

// NOTE: On submit return for each API call
export interface OnSubmitReturn {
  error: ErrorResponse | null;
}

// NOTE: On submit return for each input type
export interface OnSubmitInput extends InputValue {
  hasError: boolean;
  name: string;
}

@Component({
  components: { Input, TextArea, MainButton, Dropdown, DropdownSubject },
})
export default class Form extends Vue {
  @Prop({ default: 'Submit Form' })
  buttonLabel: string;

  @Prop({ default: 'Submit Form Second' })
  secondButtonLabel: string;

  @Prop({ required: true })
  inputs: InputData[];

  @Prop({ default: false })
  isDisable: boolean;

  @Prop({ default: false })
  isInline: boolean;

  @Prop({ default: false })
  showLabel: boolean;

  @Prop({ default: null })
  buttonDescription: string | null;

  @Prop({ required: true })
  onSubmit: (bodyRequest: any) => Promise<OnSubmitReturn | null>;

  @Prop({ default: null })
  onSubmitSecondary: (
    bodyRequest: any,
  ) => Promise<OnSubmitReturn | null> | null;

  @Prop({ default: null })
  onCancel: () => void;

  @Prop({ default: null })
  closeModal: () => void;

  isLoading = false;
  isFormLoading = false;
  submitInputs: (() => Promise<OnSubmitInput>)[] = [];

  mounted() {
    this.$emit('formSubmittedAdd', this.formSubmitted);
  }

  async formSubmitted(isPrimarySubmit = true) {
    if (this.isLoading || this.isFormLoading || this.isDisable) return;

    this.isLoading = true;

    // NOTE: A body request to use for API
    const bodyRequest = {};

    let hasError = false;

    for (const submitInput of this.submitInputs) {
      const submitInputResult = submitInput && (await submitInput());

      if (submitInputResult.hasError) {
        hasError = submitInputResult.hasError;
      }

      const selectedInput = this.inputs.find(
        input => input.name === submitInputResult.name,
      );

      if (selectedInput) {
        selectedInput.value = submitInputResult.value;
        bodyRequest[selectedInput.name] = selectedInput.value;
      }
    }

    if (!hasError) {
      // NOTE: Start calling API
      let onSubmitReturn: OnSubmitReturn | null = null;

      if (isPrimarySubmit) {
        onSubmitReturn = await this.onSubmit(bodyRequest);
      } else {
        onSubmitReturn = await this.onSubmitSecondary(bodyRequest);
      }

      if (onSubmitReturn && onSubmitReturn.error) {
        this.$toasted.global.mainToast({
          message: onSubmitReturn.error.message,
        });
      } else {
        this.closeModal && this.closeModal();
      }
    }

    this.isLoading = false;
  }

  addSubmitInput(submitInput: any) {
    if (submitInput) {
      this.submitInputs.push(submitInput);
    }
  }

  updateIsFormLoading(loadingStatus: boolean) {
    this.isFormLoading = loadingStatus;
  }
}
